import {CONFIG} from '../../../globals/config';
import {decodeEntities} from '@wordpress/html-entities';
import {SelectControl} from '@wordpress/components';
import {SetAttributes} from './Edit';
import {__} from '@wordpress/i18n';

export type PostTypeOptions = {
	post_type: string;
}

type Props = {
	attributes: PostTypeOptions;
	setAttributes: SetAttributes;
};

const PostType = ( {attributes, setAttributes}: Props ) => {
	// If we only have "Pages" we don't render the select.
	const postTypes = Object.keys( CONFIG.postTypes ).length > 1 ? CONFIG.postTypes : {};

	return (
		<SelectControl
			label={__( 'Post type', 'advanced-sidebar-menu' )}
			value={attributes.post_type}
			labelPosition={'side'}
			options={Object.entries( postTypes ).map( ( [ value, label ] ) => ( {
				value,
				label: decodeEntities( label ),
			} ) )}
			onChange={value => {
				setAttributes( {
					post_type: value,
				} );
			}} />
	);
};

export default PostType;
